// services/dashboardService.js
import api from "./api";

export const getDashboardStats = async (schemaName = null) => {
  try {
    const response = await api.get("/dashboard/stats/", {
      params: schemaName ? {  client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    throw error;
  }
};

// Get specific time range stats
export const getDashboardStatsWithTimeRange = async ({
  startDate = "",
  endDate = "",
}) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const response = await api.get("/dashboard/stats/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats with time range:", error);
    throw error;
  }
};

// Get historical stats for trends
export const getDashboardHistoricalStats = async (days = 7) => {
  try {
    const params = new URLSearchParams({
      days: days.toString(),
    });

    const response = await api.get("/dashboard/stats/historical/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching historical dashboard stats:", error);
    throw error;
  }
};
